angular.module('picmonicng').directive('plsMenuQuiz', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/directives/pls-menu-quiz.html',
      controller: [
        '$scope',
        'QuizService',
        'UserService',
        function ($scope, QuizService, UserService) {
          $scope.QuizService = QuizService;
          $scope.UserService = UserService;
        },
      ],
    };
  },
]);
